<div class="flex flex-col">
  <div class="flex justify-end" id="token-timer-outlet">
    <div #timerOutlet></div>
  </div>
  <div class="hidden">
    <div #tokenTimerOutlet></div>
  </div>
  <div class="mt-6 flex flex-col lg:flex-row gap-4 min-h-0 w-full flex-1">
    <div class="flex-1 h-full">
      <div
        class="flex flex-col gap-4 h-full w-full p-14 bg-white border-gray-500 rounded-xl shadow-lg hover:bg-white dark:bg-white dark:border-gray-500 dark:hover:bg-white">
        @if(problem()) {
          <h5 class="text-4xl font-semibold tracking-tight text-black dark:text-black">
            {{ problem()?.title }}
          </h5>
          <div [innerHTML]="problem()?.description">
          </div>
        }
        @else{
          <p class="text-gray-400 text-4xl ">Loading . . . </p>
        }
      </div>
    </div>
    <div class="flex-shrink-0 lg:w-[60%] flex flex-col gap-4 min-h-0">
      <div
        class="h-[60vh] sm:h-[65vh] md:h-[70vh] bg-white rounded-xl shadow-lg overflow-hidden flex flex-col flex-shrink-0">
        <div class="w-full flex flex-row items-center px-7 py-6 flex-shrink-0">
          <p class="w-full font-semibold text-2xl">Write your code here..</p>
          <div class="flex w-full justify-end">
            <app-select
              id="language-select"
              name="language-select"
              [items]="languageItems()"
              [(selectedItem)]="selectedLanguage"
            />
          </div>
        </div>
        <div class="flex-1 min-h-0">
          <div #codeEditorOutlet></div>
        </div>
      </div>
      <div class="flex-shrink-0">
        <app-test-case-card
          (runTestClick)="handleRunTest()"
          (submitClick)="handleSubmit()"
          [testCaseDetails]="testCaseDetail()"
          [running]="running()"
          [disabled]="disabled()"
          id="test-case-card"/>

        <!-- show error -->
        @if (errorMessage()) {
          <div
            class="mt-4 p-4 bg-error-subtle border border-error text-error rounded-xl">
            <div class="flex items-center">
              <svg class="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fill-rule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                  clip-rule="evenodd"></path>
              </svg>
              <span class="font-medium">{{ errorMessage() }}</span>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
